import React from 'react';
import './index.css';

type ButtonProps = {
    children?: React.ReactNode;
    className?: string;
    disabled?: boolean;
    onClick?: () => void;
    secondary?: boolean;
    type?: 'button' | 'submit' | 'reset' | undefined;
};

function Button({
    children,
    className,
    disabled,
    onClick,
    secondary,
    type
}: ButtonProps) {
    return (
        <button
            className={`
                button
                ${secondary && 'button--secondary'}
                ${disabled && 'button--disabled'}
                ${className}
            `}
            disabled={disabled}
            onClick={onClick}
            type={type}
        >
            {children}
        </button>
    );
}

export default Button;